module.exports = __webpack_public_path__ + "media/32.a64651bb.ogg";